var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maxBox",staticStyle:{"height":"800px","margin-top":"25px"}},[_c('div',{staticClass:"dplayerBox",style:(_vm.dplayerData.style),attrs:{"id":"dplayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }